import React, { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const useGlobal = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }) => {
  const [rolePermissionList, setRolePermissionList] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("rolePermissionList")) || [];
    } catch {
      return [];
    }
  });
  const [userType, setUserType] = useState(() => localStorage.getItem("userType") || "");
  const [orgImage, setOrgImage] = useState("");

  return (
    <GlobalContext.Provider
      value={{
        rolePermissionList,
        setRolePermissionList,
        userType,
        setUserType,
        orgImage,
        setOrgImage,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
